import React, {useState, useEffect} from 'react';
import {Helmet, HelmetProvider} from 'react-helmet-async';
import {confirmAlert} from 'react-confirm-alert';
import useSpacesHook from '../../../api/spaces';
import ViewSpaces from '../../../components/admin/spaces/ViewSpaces';
import { useTranslation } from 'react-i18next';

import {
    Spinner,
    Pagination,
    Message,
    Confirm, Search,
} from '../../../components';

const Spaces = () => {
    const { t } = useTranslation();

    const [page, setPage] = useState(1);
    const [q, setQ] = useState('');

    const {getSpaces, deleteSpace} = useSpacesHook({ page, q });

    const {
        data,
        isLoading,
        isError,
        error,
        refetch,
        isFetching,
        dataUpdatedAt
    } = getSpaces;

    const {
        isLoading: isLoadingDelete,
        mutateAsync: mutateAsyncDelete,
    } = deleteSpace;

    useEffect(() => {
        if (q.trim() || page) {
            refetch();
        }
    }, [page, q, refetch]);

    const searchHandler = (e) => {
        e.preventDefault();
        refetch();
        setPage(1);
    };

    const deleteHandler = (id) => {
        confirmAlert(Confirm(() => mutateAsyncDelete(id)));
    };

    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>Spaces</title>
                    <meta property='og:title' content='Spaces' key='title'/>
                </Helmet>
            </HelmetProvider>

            <div className='view-list-top-bar'>
                <h3 className='fw-light text-muted text-center mb-3'>
                    {t("Spaces List")} <sup className='fs-6'> [{data && data.total}] </sup>
                </h3>

                <div className='d-flex align-items-center justify-content-between mb-2'>
                    <button
                        className='btn add-new-entry-button align-self-end'
                        onClick={() => window.open('/admin/spaces/new', '_blank')}
                    >
                        {t("Add New Space")}
                    </button>
                    <Pagination data={data} setPage={setPage}/>
                </div>

                <div className='col-auto full-search'>
                    <Search
                        placeholder={`${t('Search by')} ${t('Name')}, ${t('Address')}, ${t('Category')}`}
                        setQ={setQ}
                        q={q}
                        searchHandler={searchHandler}
                    />
                </div>
            </div>

            {isLoading ? (
                <Spinner/>
            ) : isError ? (
                <Message variant='danger'>{error}</Message>
            ) : (
                <ViewSpaces
                    data={data}
                    editHandler={(space) => window.open(`/admin/spaces/${space._id}/edit`, '_blank')}
                    deleteHandler={deleteHandler}
                    isLoadingDelete={isLoadingDelete}
                    t={t}
                    onRefresh={refetch}
                    isRefreshing={isFetching}
                    lastUpdatedAt={dataUpdatedAt}
                />
            )}
        </>
    );
}

export default Spaces;
